export function formatApartmentResidentLabel(apartment: {
  code: string;
  ownerName?: string | null;
}): string {
  const code = apartment.code?.trim();
  const ownerName = apartment.ownerName?.trim() || '';
  const codeLabel = code ? `Chủ hộ ${code}` : 'Chủ hộ';

  if (!ownerName) {
    return codeLabel;
  }

  const placeholderMatch = ownerName.match(/^Chủ hộ\s+(.+)$/i);
  if (placeholderMatch && placeholderMatch[1]?.trim() !== code) {
    return codeLabel;
  }

  return ownerName;
}

export function formatApartmentChatTitle(apartment: {
  code: string;
  ownerName?: string | null;
  building?: { name?: string | null } | null;
}): string {
  const label = formatApartmentResidentLabel(apartment);
  const building = apartment.building?.name?.trim() || '';
  return `${apartment.code} - ${label}${building ? ` (${building})` : ''}`;
}
